import { render } from "./DashboardBrandManagement.vue?vue&type=template&id=9694085c&scoped=true&ts=true"
import script from "./DashboardBrandManagement.vue?vue&type=script&lang=ts"
export * from "./DashboardBrandManagement.vue?vue&type=script&lang=ts"

import "./DashboardBrandManagement.vue?vue&type=style&index=0&id=9694085c&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9694085c"]])

export default __exports__